import { Heading } from '@astryxdesign/core/Heading';
import { Item } from '@astryxdesign/core/Item';
import { List } from '@astryxdesign/core/List';
import { HStack, VStack } from '@astryxdesign/core/Stack';
import { Text } from '@astryxdesign/core/Text';
import { Button } from '@astryxdesign/core/Button';
import { EmptyState } from '@astryxdesign/core/EmptyState';
import { useBookingNav, useStudio } from '../app/studio';
import { Reveal } from '../components/Reveal';
import { durationLabel, money } from '../lib/time';

export function ServicesPage() {
  const studio = useStudio();
  const booking = useBookingNav();
  const groups = new Map<string, typeof studio.services>();
  for (const s of studio.services) {
    const k = s.category ?? 'Услуги';
    groups.set(k, [...(groups.get(k) ?? []), s]);
  }
  return (
    <main className="app-page app-page--top">
      <VStack gap={6}>
        <VStack gap={1} paddingInline={5}>
          <Heading level={1}>Услуги и цены</Heading>
          <Text color="secondary">Цена фиксируется в момент записи. Длительность — время работы с машиной.</Text>
        </VStack>
        {studio.services.length === 0 && <EmptyState title="Услуги пока не добавлены" description="Позвоните в студию, чтобы записаться." />}
        {[...groups.entries()].map(([cat, list], gi) => (
          <Reveal key={cat} delay={gi * 40}>
            <VStack gap={1}>
              <HStack paddingInline={5}>
                <Heading level={2}>{cat}</Heading>
              </HStack>
              <VStack paddingInline={2}>
              <List hasDividers density="spacious">
                {list.map((s) => (
                  <Item
                    key={s.id}
                    align="start"
                    label={<Text weight="semibold">{s.name}</Text>}
                    description={
                      <VStack gap={1}>
                        {s.description && <Text color="secondary">{s.description}</Text>}
                        <Text type="supporting">
                          {durationLabel(s.duration_min)}
                          {s.duration_min >= 1440 ? ' · машина остаётся в студии' : ''}
                        </Text>
                      </VStack>
                    }
                    endContent={
                      <VStack gap={2} hAlign="end">
                        <Text weight="semibold" hasTabularNumbers>
                          {money(s.price, studio.currency, s.price_from)}
                        </Text>
                        <Button label="Записаться" size="sm" variant="primary" onClick={() => booking.open(s.id)} />
                      </VStack>
                    }
                  />
                ))}
              </List>
              </VStack>
            </VStack>
          </Reveal>
        ))}
      </VStack>
    </main>
  );
}
